import Component from '@ember/component';
import { action, set } from '@ember/object';
import { service } from '@ember/service';

/*
  attrs
  - cancelRoute
    - the route name to go if cancel is clicked
    - if blank, then window.history.back() is used
  - deleteTask
    - the task to run when save is clicked
*/

export default Component.extend({
  router: service(),
  cancelRoute: null,
  deleteTask: null,

  // pointer to deleteTask that is performing
  // this is used so it can be cancelled if cancel is clicked
  deleteTaskInstance: null,

  willDestroyElement() {
    this._super(...arguments);
    let deleteTaskInstance = this.deleteTaskInstance;
    if (deleteTaskInstance != null) {
      deleteTaskInstance.cancel();
    }
  },

  delete: action(function () {
    let deleteTaskInstance = this.deleteTask.perform();
    set(this, 'deleteTaskInstance', deleteTaskInstance);
  }),

  cancel: action(function () {
    // TODO: replace if/else statement in HBS once Ember 2.15 lands and components
    // can use the route service
    let cancelRoute = this.cancelRoute;
    if (cancelRoute) {
      //get(this, 'router').transitionTo(cancelRoute);
    } else {
      window.history.back();
    }
  }),
});
